import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../../contexts/DataContext";
import styled from "styled-components";
import Games from "../Games/Games";
import Live from "./Live";
import { useParams, Switch, Route } from "react-router-dom";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import LeftSideBar from "../LeftSideBar/LeftSideBar";
import NavBar from "../TopBar/NavBar";
import Tackles from "./Stats/Tackles";
import PlayerStats from "./Stats/PlayerStats";
import Fruit from "./Fruit";
import StatsTeamSelect from "./StatsTeamSelect";
import Config from "../Popup/Config";
import Data from "./Data";
import CompetitionSelect from "../Fruit/CompetitionSelect";
import CommsSelect from "../Commentators/CommSelect";
import Comms from "./Comms";
import CommsGames from "../Commentators/CommsGames";
import NavBarMobile from "../TopBar/NavBar_Mobile";
const MainDiv = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
`;
const LeftBar = styled.div`
  display: flex;
  min-width: 44px;
  box-shadow: 3px -1px 3px 0 rgb(0 0 0 / 42%);
  background-color: #202731;
`;
const Content = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  width: 100vw;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export default function Main() {
  const { view, setView, editPlayer, setEditPlayer } = useContext(UIContext);
  const [showConfig, setShowConfig] = useState(false);
  const { teams, fixtures, selectedGame, setSelectedGame, players } =
    useContext(DataContext);
  const { animateGraphic, graphicInPreview, animateOffGraphic, clearPVW } =
    useContext(GraphicsContext);
  const { setSelectedGameID } = useContext(DataContext);

  const [selectedPlayer, setSelectedPlayer] = useState();
  let { gameID } = useParams();

  useEffect(() => {
    if (players && selectedPlayer) {
      let p = players.find((p) => p.uuid === selectedPlayer.player);
      setSelectedPlayer({ ...p, player: p.uuid });
    }
  }, [players]);

  useEffect(() => {
    if (gameID) {
      setSelectedGameID(gameID);
      if (view === VIEW_CONSTS.matchSelect) {
        setView(VIEW_CONSTS.live);
      }
    } else {
      setView(VIEW_CONSTS.matchSelect);
      setSelectedGame(null);
    }
  }, [fixtures, gameID]);

  useEffect(() => {
    function handleKeyDown(e) {
      console.log(e.keyCode);
      if (e.keyCode === 119 || e.keyCode === 109) {
        if (graphicInPreview) {
          animateGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 120 || e.keyCode === 106) {
        if (graphicInPreview) {
          animateOffGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 81 && e.ctrlKey) {
        if (graphicInPreview) {
          clearPVW(graphicInPreview.name);
        }
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [graphicInPreview]);

  return (
    <div>
      <Content>
        <Switch>
          <Route path="/tackles/:gameID">
            <LeftBar>
              <LeftSideBar view={VIEW_CONSTS.tackle} />
            </LeftBar>
            <Tackles />
          </Route>
          <Route path="/tackles">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.tackle} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
          <Route path="/players/:gameID/:team_type">
            <MainDiv>
              <LeftBar>
                <LeftSideBar view={VIEW_CONSTS.logger} />
              </LeftBar>
              <PlayerStats />
            </MainDiv>
          </Route>
          <Route path="/players/:gameID">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.logger} />
                </LeftBar>
                <StatsTeamSelect />
              </MainDiv>
            </Column>
          </Route>
          <Route path="/players">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.logger} />
                </LeftBar>
                <Games
                  iPad={true}
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
          <Route path="/fruit/:competition">
            <Fruit />
          </Route>
          <Route path="/fruit">
            <CompetitionSelect />
          </Route>
          <Route path="/comms/:gameID/:commID">
          <Column>
              {!window.hideHeader && <NavBarMobile 
              view={VIEW_CONSTS.comms}/>}
              <MainDiv>
            <Comms />
           </MainDiv>
            </Column>
          </Route>
          <Route path="/comms/:gameID">
          <Column>
              {!window.hideHeader && <NavBarMobile 
              view={VIEW_CONSTS.comms}/>}
              <MainDiv>
            <CommsSelect />
            </MainDiv>
            </Column>
          </Route>
          <Route path="/comms">
          <Column>
              {!window.hideHeader && <NavBarMobile 
              view={VIEW_CONSTS.comms}/>}
              <MainDiv>
                <CommsGames
                  iPad={true}
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>

          <Route path="/data">
            <Data />
          </Route>
          <Route path="/:gameID">
            <LeftBar>
              <LeftSideBar
                view={VIEW_CONSTS.live}
                setShowConfig={setShowConfig}
              />
            </LeftBar>
            <Live
              setSelectedPlayer={setSelectedPlayer}
              selectedPlayer={selectedPlayer}
              view={view}
              setView={setView}
            />
            {showConfig && <Config title="Config" />}
          </Route>
          <Route path="/">
            <Column>
              {!window.hideHeader && <NavBar />}

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
        </Switch>
      </Content>
    </div>
  );
}
